import React, { useEffect } from 'react';
import 'src/styles/SampleDetails.css';
import { styled, Typography } from '@mui/material';
import { useSampleDetails } from 'src/common/hooks/useSampleDetails';
import { RouteComponentProps, withRouter } from 'react-router';
import PreloaderSkeleton from './PreloaderSkeleton';
import TopPanel from './TopPanel';
import { getSampleDetailsSections } from 'src/common/funcs/sampleDetailsFields';

export type SampleDetailsProps = {
  sampleId?: string;
};

const SampleDetailsPage = (props: RouteComponentProps<SampleDetailsProps>) => {
  const { sampleId } = props.match.params;
  const [{ sample, loading }, loadData] = useSampleDetails();
  const sections = getSampleDetailsSections(sample, true);

  useEffect(() => {
    if (sampleId) {
      loadData(parseInt(sampleId));
    }
  }, [sampleId]);

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <TopPanel />
      <SampleDetailsWrapper>
        {loading ? (
          <PreloaderSkeleton />
        ) : sections.map((section, index) => (
          <div key={index} className="sample-details-section">
            <Typography
              variant="h5"
              paragraph={false}
              className="sample-details-section-header"
            >
              {section.title}
            </Typography>
            <div className="sample-details-content">
              {section.fields.map((detail, index) => (
                <React.Fragment key={index}>
                  <span>{detail.label}:</span>
                  <span>{detail.value || ""}</span>
                </React.Fragment>
              ))}
            </div>
          </div>
        ))}
      </SampleDetailsWrapper>
    </div>
  );
};

export default withRouter(SampleDetailsPage);

const SampleDetailsWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  flex: 1,
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  maxWidth: 2000
}));